<template>
    <v-dialog persistent v-model="get_dialogMain.dialog" :width="get_dialogMain.withWindows" justify-center>
      <v-card width="auto" tile>
          <v-toolbar dense dark color="primary darken-2">
            <v-toolbar-title><h3>{{get_dialogMain.title}}</h3></v-toolbar-title>
                <v-spacer/>
            <v-btn icon dark @click="HIDDE_DIALOG_MAIN"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text class="pa-2">
            <MainProcessForm v-if="get_dialogMain.form === 'form'" :model="nomina" :form="form" :on-success="saveNomina" :on-cancel="cancel"/>
            <MainGeneralForm v-if="get_dialogMain.form === 'gral'" :model="nomina" :form="form" :on-success="saveNomina" :on-cancel="cancel"/>
            <NominaDetailConceptsForm v-if="get_dialogMain.form === 'NominaDetalleConceptos'" :model="view" :on-cancel="cancel"/>
            <ImportDataForm v-if="get_dialogMain.form === 'importData'" :model="nomina" :itemAction="form" :on-success="saveNominaImport" :on-cancel="cancel"/>

          <v-alert type="error" v-if="show">
            <v-row align="center">
              <v-col class="grow">
                <p class="font-weight-bold">{{ error.message }}</p>
              </v-col>
              <v-col cols="12" class="grow">
                <v-virtual-scroll v-if="error.list" :items="error.list" :item-height="35" height="300">
                  <template v-slot="{ item }">
                    <v-list-item :key="item" :value="item">
                      <v-list-item-content>
                        <v-list-item-title v-text="item" />
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-virtual-scroll>
              </v-col>

            </v-row>

          </v-alert>
          </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import MainProcessForm from '@/components/forms/main/MainProcessForm'
import MainGeneralForm from '@/components/forms/main/MainGeneralForm'
import ImportDataForm from '@/components/forms/main/ImportDataForm'

import NominaDetailConceptsForm from '@/components/forms/nomina/NominaDetailConceptsForm'

export default {
  props: ['model', 'params', 'view', 'onSuccess'],
  data: () => ({
    form: {
      status_start: {
        formulario: {
          fields: []
        }
      },
      status_finish: {
        formulario: {
          fields: []
        },
        estatus: ''
      }
    },
    nomina: {},
    confirmNomina: {},
    show: false,
    error: {
      list: null,
      message: null
    }
  }),
  components: {
    MainProcessForm,
    MainGeneralForm,
    ImportDataForm,
    NominaDetailConceptsForm
  },
  mounted () {
    if (this.view) {
      return
    }
    if (this.params) {
      if (this.params.form) {
        this.form = this.params.form
        return
      }
    }
    if (this.model.action) {
      this.form = this.model.body
    } else {
      this.getFormServices('GET/nomina/options/{procss}[/{id}]')
    }
    if (this.get_dialogMain.body.setModel) {
      this.nomina = this.model
    }
  },
  methods: {
    ...mapActions(['GetFormOptionServicesAction', 'postExecuteAction']),
    saveNomina (model) {
      if (this.get_dialogMain.type !== 'create') {
        if (this.model.item) model.id = this.model.item.id
      }

      if (this.params) {
        if (this.params.returnObjet) {
          this.onSuccess({ name: this.get_dialogMain.type, model: model })
          this.cancel()
          return
        }
      }
      this.confirmNomina = model
      const router = this.get_urls['POST/nomina/execute']
      this.postExecuteAction({ url: router, data: model })
    },
    saveNominaImport (model) {
      console.log('importador', model)
    },
    cancel () {
      this.HIDDE_DIALOG_MAIN()
    },
    // * ========== * ========== * ========== * ========== * ========== *
    getFormServices (url) {
      const router = this.get_urls[url]
      this.GetFormOptionServicesAction({ url: router, data: {}, params: '/1' })
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'SET_DATA', 'CLEAR_DATA'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_options', 'get_model'])
  },
  watch: {
    get_options (val) {
      if (val) {
        this.form = val
      }
    },
    get_model (val) {
      if (val.message) {
        if (val.list) { // solo aplica para validar faltas.
          this.error = val
          this.show = true
          return
        }
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitoso!',
        text: 'Registro agregado correctamente'
      })
      this.SET_DATA(val)
      this.cancel()
    }
  }
}
</script>

<style>

</style>
